export default {
  'sidebar.button.settings': 'Einstellungen'
};



// WEBPACK FOOTER //
// ./client/src/javascript/i18n/de.js